import DrawerDetailStudents from "./DrawerFull";
import StudentsDetails from "../pages/StudentsDetails";
import { useStudentModalStore } from "../stores/studentModal";

const StudentDrawerHost = () => {
  const { isOpen, data, closeModal } = useStudentModalStore();

  return (
    <DrawerDetailStudents open={isOpen} onClose={closeModal}>
      <StudentsDetails id={data?.id} />
    </DrawerDetailStudents>
  );
};

export default StudentDrawerHost;
